import { render, staticRenderFns } from "./tagViewItem.vue?vue&type=template&id=7282160f&"
import script from "./tagViewItem.vue?vue&type=script&lang=js&"
export * from "./tagViewItem.vue?vue&type=script&lang=js&"
import style0 from "./tagViewItem.vue?vue&type=style&index=0&id=7282160f&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/tagViewItem.vue
// module id = 495
// module chunks = 30